<template>
  <div class="article-major-panel">
    <div class="article-major-tag" v-if="hasAttachment">标题</div>

    <div class="active-panel-up">
      <input
        type="text"
        maxlength="50"
        class="article-title"
        v-model="post.postTitle"
        placeholder="请输入标题(长度不能超过50个字)"
      />

      <div v-if="hasAttachment">
        <div class="operation-wrapper">
          <button
            class="eims-button--text add-attachment"
            type="text"
            size="small"
            @click="dialogVisible = true"
          >
            添加附件
          </button>
          <button
            class="eims-button--text add-attachment"
            type="text"
            size="small"
            @click="handleClearAll"
          >
            删除所有
          </button>
        </div>

        <div class="attachment-wrapper">
          <div
            v-for="(item, index) of post.attachments"
            :key="item.id"
            class="attachment-item"
          >
            <span
              class="attachment-original-name"
              :title="
                item.attachmentName
                  ? item.attachmentName
                  : item.attachmentOriginalName
              "
              >{{
                item.attachmentName
                  ? item.attachmentName
                  : item.attachmentOriginalName
              }}
            </span>
            <button
              class="eims-button--text attachment-btn"
              type="text"
              size="mini"
              @click="handleUpdateAttachment(item, index)"
            >
              别名
            </button>
            <button
              class="eims-button--text attachment-btn"
              type="text"
              size="mini"
              @click="handlePreview(item)"
            >
              预览
            </button>
            <button
              class="eims-button--text attachment-btn"
              type="text"
              size="mini"
              @click="removeAttachment(item, index)"
            >
              删除
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="active-panel-down">
      <TinymceEditor :content.sync="post.postContent" />
    </div>

    <common-dialog
      width="30%"
      title="修改附件的别名"
      :visible.sync="updateAttachmentNameVisible"
      modal-append-to-body
      append-to-body
    >
      <div>
        <div class="input-tag">
          <div>附件原名</div>
          <el-input
            disabled
            v-model="updateAttachment.attachmentOriginalName"
          ></el-input>
        </div>
        <div class="input-tag">
          <div>附件别名</div>
          <el-input
            v-model="updateAttachment.newAttachmentName"
            placeholder="输入附件的别名"
          ></el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <common-button
          @click="updateAttachmentNameVisible = false"
          class="operation-btn"
          type="cancel"
          >取消</common-button
        >
        <common-button
          @click="handleSureUpdateAttachmentName"
          type="primary"
          class="operation-btn"
          >确定
        </common-button>
      </span>
    </common-dialog>
    <!-- 附件预览弹窗 -->
    <dialog-preview
      :preViewObj="preViewObj"
      :showPreview="showPreview"
      @handleClosePreview="showPreview = false"
    />
    <historical-attachment
      :dialogVisible.sync="dialogVisible"
      :hasCaseShare="hasCaseShare"
      @AddAttachment="AddAttachment"
    />
  </div>
</template>

<script>
import TinymceEditor from "../tinymce/TinymceEditor";
import HistoricalAttachment from "../common/HistoricalAttachment";

export default {
  name: "ArticleMajorContent",
  components: { TinymceEditor, HistoricalAttachment },

  props: {
    hasAttachment: {
      type: Boolean,
      default: false
    },
    hasMembers: {
      type: Boolean,
      default: false
    },
    hasCaseShare: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      updateAttachmentNameVisible: false,
      showPreview: false,
      dialogVisible: false,
      preViewObj: null,
      post: {
        postTitle: "",
        postContent: "",
        totalAttaSize: null,
        createUserId: null,
        createTm: null,
        attachments: []
      },

      //需要修改别名的附件
      updateAttachment: {
        //新的附件的别名
        newAttachmentName: null
      },

      attachmentsMultipart: []
    };
  },

  mounted() {
    this.initPage();
  },
  methods: {
    handleSureUpdateAttachmentName() {
      this.updateAttachment.attachmentName = this.updateAttachment.newAttachmentName;
      this.updateAttachment.newAttachmentName = null;
      this.updateAttachmentNameVisible = false;
    },

    handleClearAll() {
      this.post.attachments = [];
      this.attachmentsMultipart = [];
    },

    handleUpdateAttachment(row, index) {
      this.updateAttachmentNameVisible = true;
      this.updateAttachment = row;
    },

    removeAttachment(row, index) {
      this.attachmentsMultipart.splice(index, 1);
      this.post.attachments.splice(index, 1);
    },

    initPage() {
      window.addEventListener("resize", this.timeOutChange);
      this.$nextTick(args => {
        this.timeOutChange();
      });
    },

    timeOutChange() {},

    //外部调用此方法即返回postTitle和postContent文本
    getArticleData(item = {}) {
      item.postTitle = this.post.postTitle;
      item.postContent = this.post.postContent;
      item.attachmentsMultipart = this.attachmentsMultipart;
      item.attachments = this.post.attachments;
      item.totalAttaSize = this.post.totalAttaSize;
      item.createUserId = this.post.createUserId;
      item.createTm = this.post.createTm;
    },

    //清空数据
    clearArticleData() {
      this.post = this.$options.data().post;
      this.attachmentsMultipart = this.$options.data().attachmentsMultipart;
    },
    handlePreview(item) {
      this.preViewObj = item;
      this.showPreview = true;
    },
    AddAttachment(files, attachmentsMultipart) {
      if (attachmentsMultipart)
        this.attachmentsMultipart.push(...attachmentsMultipart);
      this.post.attachments.push(...files);
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.timeOutChange);
  }
};
</script>

<style lang="scss" scoped>
.article-major-panel {
  display: flex;
  flex-direction: column;
  height: calc(100%);
  .article-major-tag {
    height: 22px;
    line-height: 20px;
    font-size: 16px;
    color: #888888;
  }
  .active-panel-up {
    overflow: auto;
    .article-title {
      width: calc(100% - 20px);
      margin: 2.5px 0;
      height: 35px;
      outline: none;
      padding: 0 15px;
      border-radius: 5px;
      border: 1px solid #d7d7d7;
    }

    .article-title:focus {
      border: 1px solid var(--mainbgcActive);
    }
    .operation-wrapper {
      height: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .upload-btn {
        margin-left: 0;
      }
    }

    .operation-wrapper > * {
      margin: 0 10px;
    }
    .attachment-wrapper {
      max-height: 65px;
      line-height: 25px;
      padding: 2px;
      margin: 2.5px 10px;
      overflow: auto;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .attachment-item {
        display: flex;
        flex-direction: row;
        border-right: 1px solid #d9d9d9;
        margin: 0 8px 4px;
        padding-right: 8px;
      }

      .attachment-item:last-child {
        border-right: none;
      }

      .attachment-name {
        outline: none;
        border: 1px solid #bababa;
        padding: 0 10px;
        border-radius: 5px;
        height: 28px;
        vertical-align: top;
        width: 20%;
      }

      .attachment-name:focus {
        outline: none;
        border: 1px solid var(--mainbgcActive);
        padding: 0 10px;
        border-radius: 5px;
        height: 28px;
        vertical-align: top;
        width: 20%;
      }

      .attachment-original-name {
        max-width: 100px;
        color: #bababa;
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-right: 5px;
        cursor: pointer;
      }

      .attachment-btn {
        vertical-align: top;
        margin: 0 4px;
      }
    }
  }

  .active-panel-down {
    margin: 2.5px 0;
    overflow: auto;
    /*填充剩下的所有空间*/
    flex: 1;
  }
}
.input-tag {
  // margin-bottom: 15px;
}
@media (min-width: 1024px) {
  #sample {
    display: flex;
    flex-direction: column;
    place-items: center;
    width: 1000px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/article/ArticleMajorContent.vue